import { Box, IconButton } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "assets/CloseIcon";
import ThemeContext from "components/app/Context";
import Typography from "components/common/Typography";
import { useContext } from "react";
import { tokens } from "styles/Tokens";

interface Sx {
  dialogPaper?: object;
  dialogContent?: object;
  closeBox?: object;
  dialogAction?: object;
  dialog?: any;
}

interface Props {
  Open?: any;
  title?: string;
  children?: any;
  actionConfig?: any;
  handleCloseDialog?: () => void;
  sx?: Sx;
}
export default function FormDialog(props: Props) {
  const { Open, handleCloseDialog, title, children, actionConfig, sx } = props;
  const { isMobileScreen } = useContext(ThemeContext);
  return (
    <>
      <Dialog
        fullWidth={true}
        fullScreen={isMobileScreen}
        maxWidth={sx?.dialog?.maxWidth}
        sx={isMobileScreen ? { paddingTop: "76px", zIndex: "1299" } : {}}
        open={Open}
        PaperProps={{
          sx: { ...sx?.dialogPaper }
        }}
      >
        <Box sx={{ margin: "23.71px 23.71px 23.71px auto", ...sx?.closeBox }}>
          <IconButton onClick={handleCloseDialog}>
            <CloseIcon />
          </IconButton>
        </Box>
        {title && (
          <DialogTitle component="div" id="alert-dialog-title" sx={{ textAlign: "center" }}>
            <Typography variant="h5" showBold color={tokens.Text.General.PrimaryHeadline}>
              {title}
            </Typography>
          </DialogTitle>
        )}
        <DialogContent
          sx={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            ...sx?.dialogContent
          }}
        >
          {children}
        </DialogContent>
        <DialogActions sx={{ ...sx?.dialogAction }}>{actionConfig}</DialogActions>
      </Dialog>
    </>
  );
}
